import React from 'react';
import { benefitsData, ctaLink } from '../data/mock';
import { Shield, Target, CheckCircle, Globe } from 'lucide-react';

const iconComponents = {
  Shield,
  Target,
  CheckCircle,
  Globe
};

const BenefitsSection = () => {
  return (
    <section className="relative py-24 lg:py-32">
      {/* Background */}
      <div className="absolute inset-0 bg-slate-950" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[600px] bg-gradient-to-r from-cyan-500/5 via-teal-500/5 to-emerald-500/5 rounded-full blur-[150px]" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block px-4 py-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full text-sm font-medium text-emerald-400 mb-6">
              No Trade-offs
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
              Win Both{' '}
              <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
                Google & AI Search
              </span>
            </h2>
            <p className="text-lg text-slate-400 mb-8 leading-relaxed">
              Our AI-generated content doesn't hurt your Google ranking—it enhances it. Every piece follows Google's E-E-A-T guidelines while being perfectly optimized for AI citation.
            </p>

            {/* CTA */}
            <a
              href={ctaLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-emerald-500 to-cyan-500 text-slate-950 font-semibold rounded-lg shadow-lg shadow-emerald-500/25 hover:shadow-emerald-500/40 hover:scale-105 transition-all duration-300"
            >
              Start for Free
              <span>→</span>
            </a>
          </div>

          {/* Right Content - Benefits Cards */}
          <div className="grid sm:grid-cols-2 gap-4">
            {benefitsData.map((benefit, index) => {
              const Icon = iconComponents[benefit.icon];
              return (
                <div
                  key={index}
                  className="group p-6 rounded-2xl bg-white/[0.03] border border-white/5 hover:border-emerald-500/30 hover:bg-white/[0.05] transition-all duration-500"
                >
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-500/20 to-cyan-500/20 border border-emerald-500/20 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-6 h-6 text-emerald-400" />
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-emerald-300 transition-colors duration-300">
                    {benefit.title}
                  </h3>
                  <p className="text-sm text-slate-400 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
